import { useEffect, type RefObject } from 'react';

/**
 * Closes a menu when a press starts outside it (touch or mouse) or Escape is pressed. Using pointerdown in the
 * capture phase means a tap elsewhere closes the menu even if that element stops propagation.
 */
export function useDismiss(open: boolean, refs: Array<RefObject<HTMLElement | null>>, onDismiss: () => void) {
  useEffect(() => {
    if (!open) return;
    const onPointer = (event: PointerEvent) => {
      if (refs.some((ref) => ref.current?.contains(event.target as Node))) return;
      onDismiss();
    };
    // Capture phase + stopPropagation: Escape closes this menu only, not the dialog it sits in.
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') { event.stopPropagation(); onDismiss(); } };
    document.addEventListener('pointerdown', onPointer, true);
    document.addEventListener('keydown', onKey, true);
    return () => { document.removeEventListener('pointerdown', onPointer, true); document.removeEventListener('keydown', onKey, true); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
}
